import React, { createContext, useContext, useMemo, useRef, useState } from 'react';
import { Benchmark, QuestionId, benchmarkFor, createSessionId, recordResponse } from '../utils/analytics';
interface SnakSessionValue {
  sessionId: string;
  answers: Partial<Record<QuestionId, string>>;
  submit: (question: QuestionId, answer: string) => void;
  benchmark: (question: QuestionId, options: string[]) => Benchmark;
}
const SnakSessionContext = createContext<SnakSessionValue | null>(null);
export function SnakSessionProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const sessionRef = useRef<string>(createSessionId());
  const [answers, setAnswers] = useState<Partial<Record<QuestionId, string>>>({});
  const [version, setVersion] = useState(0);
  const value = useMemo<SnakSessionValue>(() => ({
    sessionId: sessionRef.current,
    answers,
    submit: (question, answer) => {
      recordResponse({
        sessionId: sessionRef.current,
        question,
        answer,
        at: Date.now()
      });
      setAnswers(prev => ({
        ...prev,
        [question]: answer
      }));
      setVersion(prev => prev + 1);
    },
    // version is a dependency so benchmarks recompute after each answer
    benchmark: (question, options) => {
      void version;
      return benchmarkFor(question, options);
    }
  }), [answers, version]);
  return <SnakSessionContext.Provider value={value} data-id="element-173" data-mp="1kyc8vy8cm27i">
      {children}
    </SnakSessionContext.Provider>;
}
export function useSnakSession(): SnakSessionValue {
  const value = useContext(SnakSessionContext);
  if (!value) {
    throw new Error('useSnakSession must be used inside a SnakSessionProvider');
  }
  return value;
}